import { render, staticRenderFns } from "./sp-organisation-edit-modal.vue?vue&type=template&id=5b28abd1&"
import script from "./sp-organisation-edit-modal.vue?vue&type=script&lang=js&"
export * from "./sp-organisation-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports